import { render } from "./SuccessModel.vue?vue&type=template&id=2a764084&scoped=true"
import script from "./SuccessModel.vue?vue&type=script&lang=js"
export * from "./SuccessModel.vue?vue&type=script&lang=js"

import "./SuccessModel.vue?vue&type=style&index=0&id=2a764084&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a764084"]])

export default __exports__